export default "__VITE_ASSET__HsGMEsPc__"